import { z } from 'zod';

export const feedbackFormSchema = z.object({
  houseNumber: z.string(),
  type: z.string({
    required_error: '類別為必填欄位',
  }),
  title: z.string().min(1, '標題為必填欄位'),
  content: z.string().max(100, '描述最多100字'),
  files: z.instanceof(FileList).optional(),
});

export type FeedbackForm = z.infer<typeof feedbackFormSchema>;
